import {PureComponent} from "react"
import {Link} from "react-router-dom"

import Card from "../Styled/Dasboard/Card.jsx"
import CardRow from "../Styled/Dasboard/CardRow.jsx"
import CardCol from "../Styled/Dasboard/CardCol.jsx"

import './BringBusiness.scss'

export default class BringBusiness extends PureComponent{
  render() {
    const {generate} = this.props
    return (
      <Card className={`bring-business-card`} title={`Apport d'affaires`}>
        <CardRow >
          <CardCol className="bring-business-card-text">
            <p className="dashboard-card-col-txt">
              Vous avez entendu parler d’une recherche de prestation chez un client (achats, finance, ingénierie, RH…) ?
              Apportez-nous des informations de marché en l’échange de 30 % de notre marge !
            </p>
          </CardCol>
          <CardCol  className="bring-business-card-cta-container">
            <Link className="btn btn-primary" to={generate({name: 'bring-business'})}>En savoir plus</Link>
          </CardCol>
        </CardRow>
      </Card>
    )
  }
}